import React from 'react'

const Tab = () => (
    <>
        &nbsp;&nbsp;&nbsp;&nbsp;
    </>
);

export default Tab;